export const cosmosApiBaseUrl = (): string =>
	(import.meta.env.VITE_COSMOS_API_BASE_URL as string | undefined)?.trim() ?? "";

export const isLocalCosmosApi = (): boolean => {
	const baseUrl = cosmosApiBaseUrl();
	return (
		baseUrl.length === 0 ||
		baseUrl.startsWith("http://localhost") ||
		baseUrl.startsWith("http://127.0.0.1")
	);
};

export const cosmosApiUrl = (path: string): string => `${cosmosApiBaseUrl()}${path}`;

export const localCosmosHeaders = (): HeadersInit => ({
	"x-cosmos-tenant-id": "default-tenant",
	"x-cosmos-user-id": "local-cosmos-user",
	"x-cosmos-roles": "admin,operator"
});
